<template>
  <div class="business-detailpage">
    <div class="header">
      <span class="goBack" @click="$router.go(-1)">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M20,11H7.83l5.59-5.59L12,4,4,12l8,8,1.41-1.41L7.83,13H20Z" />
        </svg>
      </span>
    </div>
    <div class="business-slider">
      <div class="business-img">
        <img :src="businessDetail.images[0]" />
      </div>
    </div>
    <div class="business-info">
      <div class="business-name">
        <h3>{{businessDetail.business_name}}</h3>
        <span class="business-distance">
          <img src="../assets/images/baseline-directions_walk-24px.svg" />
          {{businessDetail.distance}}
        </span>
      </div>
      <div class="review-deatil">
        <h5>{{businessDetail.cType}}</h5>
        <span class="location">
          <img src="../assets/images/icon_map_blue.svg" />
          {{businessDetail.address.street}}, {{businessDetail.address.city}}
        </span>
        <div class="review-col">
          <div class="reviews">
            <star-rating
              :read-only="true"
              :increment="0.5"
              :starSize="10"
              :rating="businessDetail.rating"
            ></star-rating>
            <!-- <span>19 Reviews</span> -->
          </div>
          <!--******* edit option ********-->
          <div class="Verified" v-if="businessDetail.is_verified">
            <img src="../assets/images/tick-g-icon.svg" />
            <span>{{$t('VerifiedbyMall91')}}</span>
          </div>

          <div class="Verified suggest_edit" @click="editDetail()" v-else>
            <!-- :to="{path: '/suggest-in-edit-Business'}" -->

            <img src="../assets/images/ic_edit.svg" />
            <span>{{$t('Suggestandedit')}}</span>
          </div>

          <!-- <router-link
            tag="div"
            v-else
            class="Verified suggest_edit"
            :to="{path: '/suggest-in-edit-Business'}"
          >
            <img src="../assets/images/ic_edit.svg" />
            <span>Suggest an edit</span>
          </router-link>-->
        </div>
      </div>
    </div>
    <div class="business-rating">
      <div class="business-block">
        <h4>{{$t('GiveRating')}}</h4>
        <div class="star-rate">
          <star-rating
            @rating-selected="setRating"
            :increment="0.5"
            :starSize="25"
            v-model="businessDetail.user_last_rating"
          ></star-rating>
        </div>
      </div>
    </div>

    <div class="business-locationdetail">
      <div class="business-block">
        <h4>{{$t('Details')}}</h4>
        <div class="business-loaction">
          <img src="../assets/images/ic_loc_details.svg" />
          <span>{{businessDetail.address.street}} {{businessDetail.address.street2}} {{businessDetail.address.city}} {{businessDetail.address.state}} {{businessDetail.address.country}}, {{businessDetail.address.zip_code}}</span>
        </div>
         <!-- <google-map /> -->

        <!-- <div class="map-img">
          <img src="../assets/images/map.jpeg" />
        </div> -->
        <div class="business-loaction">
          <img src="../assets/images/ic_map.svg" />
          <span>{{$t('MondaytoSaturday')}}</span>
        </div>
      </div>
    </div>
    <!-- <div class="loader" v-if="loading">
      <img src="../assets/images/gif-loader.gif" />
    </div>-->
    <router-link
      class="checkin"
      tag="button"
      :to="{ name: 'CheckInBusiness', params: businessDetail}"
    >{{$t('checkIn')}}</router-link>
    <div class="loader" v-if="loading">
      <img src="../assets/images/gif-loader.gif" />
    </div>
  </div>
</template>
<script>
import { toaster } from "../utils/helper";
import Button from "../components/common/Button";
import { mapState, mapMutations } from "vuex";
import Vue from "vue";
import VueCookie from "vue-cookie";
import StarRating from "vue-star-rating";
import type from "../store/types";
import Apicaller from "../utils/apicaller";
import GoogleMap from "../components/GoogleMap";
export default {
  name: "BusinessDetail",
  components: {
    Button,
    StarRating,
     GoogleMap
  },
  props: {},
  computed: {
    ...mapState(["follower"])
  },
  data() {
    return {
      businessDetail: {
        address: {}
      },
      loading: false
    };
  },
  methods: {
    ...mapMutations(["storeBusinessdetail"]),
    editDetail() {
      this.$router.push("/suggest-in-edit-Business");
    },
    setRating: function(rating) {
      var obj = {
        business_id: this.$route.params.id,
        rating_number: rating
      };
      this.$store
        .dispatch({ type: "postRating", payload: obj })
        .then(data => {
          if (data.status == "Success") {
            this.rating = rating;
          }
        })
        .catch(err => {
          toaster(this, this.$t("wentWrong"), "top-center", 2000
          );
        });
    }
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch({ type: "getBusinessDetail", payload: this.$route.params.id })
      .then(data => {
        this.loading = false;
        this.businessDetail = data[0];
        this.storeBusinessdetail(data[0]);
         
      })
      .catch(err => {
        toaster(
          this,
          this.$t("wentWrong"),
          "top-center",
          2000
        );
      });
  }
};
</script>
